export default __webpack_public_path__ + "static/Illustration_Kopernikus-128eba142583c30fac5f38f3135e127d.jpg";